import React from 'react';
import { AccordionGroup } from '@tvg/fuse/accordion-group';
import { Accordion } from '@tvg/fuse/accordion';
import { renderContent } from 'utilities/content/content-utilities';
import { PriceTerm } from 'types/Product';
import BnplContent from './BnplContent';
import ViewAllStcOptions from './ViewAllStcOptions';
import SpreadCostFurtherContent from './SpreadCostFurtherContent';
import InterestFreeContent from './InterestFreeContent';
import { DialogText } from '../../styles/DialogStyles';
import styles from './YouCouldPayOptions.module.css';

type Props = {
  longestWeeklyPriceTermWithInterest?: PriceTerm;
  longestWeeklyPriceTermWithZeroInterest?: PriceTerm;
  priceTerms?: PriceTerm[];
  productName: string;
  showBNPL: boolean;
  skuPrice: string;
};

function YouCouldPayOptions({
  longestWeeklyPriceTermWithInterest,
  longestWeeklyPriceTermWithZeroInterest,
  priceTerms,
  productName,
  showBNPL,
  skuPrice,
}: Props) {
  const options = [
    {
      id: 'stc',
      name: renderContent('littlewoods.dialog.heading.stc'),
      content: longestWeeklyPriceTermWithInterest && (
        <SpreadCostFurtherContent
          productName={productName}
          skuPrice={skuPrice}
          longestWeeklyPriceTermWithInterest={longestWeeklyPriceTermWithInterest}
        />
      ),
    },
    {
      id: 'interestFree',
      name: renderContent('littlewoods.dialog.heading.interestFree'),
      content: longestWeeklyPriceTermWithZeroInterest && (
        <InterestFreeContent
          productName={productName}
          longestWeeklyPriceTermWithZeroInterest={longestWeeklyPriceTermWithZeroInterest}
        />
      ),
    },
    {
      id: 'viewAll',
      name: renderContent('littlewoods.dialog.heading.viewAll'),
      content: priceTerms?.length && <ViewAllStcOptions priceTerms={priceTerms} />,
    },
    {
      id: 'bnpl',
      name: renderContent('littlewoods.dialog.heading.bnpl'),
      content: showBNPL && <BnplContent showFooter={false} />,
    },
  ].filter((option) => option.content);

  return (
    <>
      {options.length && (
        <AccordionGroup className={styles.accordionGroup}>
          {options.map((option) => (
            <Accordion key={option.id} heading={option.name} chevronInline={false} headingTag="h2" hideBorder>
              {option.content}
            </Accordion>
          ))}
        </AccordionGroup>
      )}

      <DialogText className={styles.footerText} tag="p" size="1" type="paragraph">
        {renderContent('littlewoods.dialog.data.footer')}
      </DialogText>
    </>
  );
}

export default YouCouldPayOptions;
